import { GroupOptions } from 'models/Group';

export interface LocationEpisodeSummaryOptions {
  id: string;
  archived: boolean;
  latest: boolean;
  hasActiveServiceRefusals: boolean;
  eligibleForProgressUpdate: boolean;
  group: Partial<GroupOptions>;
  createdAt: Date | string;
}

function getDefaults(): LocationEpisodeSummaryOptions {
  return {
    id: '',
    archived: false,
    latest: false,
    hasActiveServiceRefusals: false,
    eligibleForProgressUpdate: false,
    group: {},
    createdAt: new Date(),
  };
}
export default class LocationEpisodeSummary {
  id: string;
  archived: boolean;
  hasActiveServiceRefusals: boolean;
  latest: boolean;
  eligibleForProgressUpdate: boolean;
  group: Partial<GroupOptions>;
  createdAt: Date;

  constructor(options: Partial<LocationEpisodeSummaryOptions> = {}) {
    const opts = { ...getDefaults(), ...options };
    this.id = opts.id;
    this.archived = opts.archived;
    this.latest = opts.latest;
    this.hasActiveServiceRefusals = opts.hasActiveServiceRefusals ?? false;
    this.eligibleForProgressUpdate = opts.eligibleForProgressUpdate;
    this.group = opts.group;
    this.createdAt = new Date(opts.createdAt);
  }

  get stayDescriptor() {
    if (this.archived) return 'Canceled';
    return this.latest ? 'Current' : 'Past';
  }
}
